import { Controller } from "@hotwired/stimulus"

// Copies the token text to the clipboard and briefly confirms on the button.
// Usage:
//   div data-controller="copy-token"
//     ... data-copy-token-target="source" (element holding the token text)
//     button data-action="copy-token#copy" data-copy-token-target="button"
//            data-copied-label="Copied"
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = (this.sourceTarget.value || this.sourceTarget.textContent || "").trim()

    navigator.clipboard.writeText(text).then(() => {
      this.flashCopied()
    }).catch(() => {
      // Fallback for browsers/contexts without the async clipboard API.
      this.sourceTarget.select?.()
      document.execCommand?.("copy")
      this.flashCopied()
    })
  }

  flashCopied() {
    if (!this.hasButtonTarget) return
    const button = this.buttonTarget
    // Snapshot the current children (static markup we authored) and restore them
    // after the flash — no innerHTML string interpolation, so no XSS surface.
    const original = Array.from(button.childNodes)
    const label = button.dataset.copiedLabel || "Copied"
    const icon = document.createElement("i")
    icon.className = "fas fa-check me-2"
    button.replaceChildren(icon, document.createTextNode(label))
    button.classList.add("btn-success")
    setTimeout(() => {
      button.replaceChildren(...original)
      button.classList.remove("btn-success")
    }, 2000)
  }
}
